export default "__VITE_ASSET__DRgMJHZQ__"